import React, { useCallback, useState, useEffect, useRef } from 'react';
import classNames from 'classnames';
import Tracking from './tracking';

type LinksProps = {
    title: string;
    url: string;
};

type OverflowmenuProps = {
    links?: LinksProps[];
    callback: () => void;
    blockItem?: Array<string>;
    tracking: Tracking;
    url: string;
    showHistoryLink?: boolean;
};

const Overflowmenu: React.FC<OverflowmenuProps> = (props) => {
    const {
        callback,
        blockItem,
        tracking,
        links,
        url,
        showHistoryLink = false,
    } = props;
    const wrapperRef = useRef<HTMLDivElement>(null);
    const [isActive, setIsActive] = useState(false);
    const displaySettings = useCallback(() => {
        try {
            fetch(`${url}/tracking/overflowclick`);
        } catch (error) {}
        setIsActive(!isActive);
    }, [isActive, url]);

    const blockCurrItem = useCallback(
        (e) => {
            if (!blockItem) return;
            blockItem.forEach((blockUrl) => {
                tracking.trackWithUrl(blockUrl);
            });
        },
        [blockItem, tracking]
    );

    const handleClick = (e) => {
        if (wrapperRef.current.contains(e.target)) return;
        setIsActive(false);
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClick);
        return () => {
            document.removeEventListener('mousedown', handleClick);
        };
    }, []);

    const listStyle = {
        listStyle: 'none',
    };

    return (
        <div
            className="recommendation-overflow-menu u-position-relative u-pb4"
            ref={wrapperRef}
        >
            <button
                className="recommendations-overflow-button button button--pill button--small u-position-absolute u-right icon icon--overflow-menu-horizontal"
                onClick={(e) => {
                    e.stopPropagation();
                    displaySettings();
                }}
                aria-expanded={isActive ? 'true' : 'false'}
                aria-label="Meny for denne anbefalingen"
            ></button>
            <div
                className={classNames(
                    'u-display-none recommandations-custom-options-box u-bg-milk u-ma16 u-mt0',
                    { isActive: isActive }
                )}
            >
                <ul style={listStyle} className="u-pa0 u-ma0">
                    <li>
                        <a
                            href="/"
                            onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                callback();
                                blockCurrItem(e);
                            }}
                            className="u-caption u-pa8 u-display-block"
                        >
                            Fjern denne anbefalingen
                        </a>
                    </li>
                    {showHistoryLink ? (
                        <li>
                            <a
                                href="/anbefalinger/historikk"
                                className="u-caption u-pa8 u-display-block"
                            >
                                Hvorfor anbefaler vi denne?
                            </a>
                        </li>
                    ) : (
                        ''
                    )}
                    {links?.map((item, i) => (
                        <li key={i}>
                            <a
                                href={item.url}
                                className="u-caption u-pa8 u-display-block"
                            >
                                {item.title}
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};
export default Overflowmenu;
